import { z } from 'zod';

/**
 * Identificador universal (UUID v4).
 */
export const EntityIdSchema = z.string().uuid();
export type EntityId = z.infer<typeof EntityIdSchema>;

/**
 * Fecha en formato ISO 8601 fecha-corta (YYYY-MM-DD).
 */
export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha inválida (YYYY-MM-DD)');
export type IsoDate = z.infer<typeof IsoDateSchema>;

/**
 * Fecha+hora ISO 8601.
 */
export const IsoDateTimeSchema = z.string().datetime({ offset: true }).or(z.string().datetime());
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>;

/**
 * Hora en formato HH:MM con rango válido (00:00 a 23:59).
 */
export const HhMmSchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Hora inválida (HH:MM, 00:00–23:59)');
export type HhMm = z.infer<typeof HhMmSchema>;

/**
 * Cursor opaco devuelto por endpoints que paginan.
 * Acepta string no vacío, null (no hay más páginas), o undefined (propiedad ausente).
 * El tipo inferido es `string | null | undefined` para reflejar el caso null
 * que envía el backend, pero el shape es compatible con TanStack Query.
 */
export const CursorSchema = z.string().min(1).nullable().optional();

/**
 * Respuesta paginada genérica. `data` se sobreescribe por el endpoint concreto.
 */
export const PaginatedResponseSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    data: z.array(item),
    next_cursor: CursorSchema,
  });